import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { FloatingconfiguratorComponent } from '../../../../../layout/component/floatingconfigurator/floatingconfigurator.component';
import { LogoComponent } from '../../../../../shared/icons/logo/logo.component';

@Component({
    selector: 'app-notfound',
    standalone: true,
    imports: [RouterModule, FloatingconfiguratorComponent, ButtonModule, LogoComponent],
    templateUrl: './notfound.component.html',
    styleUrl: './notfound.component.scss'
})
export class NotfoundComponent {

}
